import themeSymbol1 from './theme/theme1.svg'
import themeSymbol2 from './theme/theme2.svg'

import empty from './avatar/empty.png'
import female1 from './avatar/female1.png'
import female2 from './avatar/female2.png'
import female3 from './avatar/female3.png'
import female4 from './avatar/female4.png'
import female5 from './avatar/female5.png'
import female6 from './avatar/female6.png'
import male1 from './avatar/male1.png'
import male2 from './avatar/male2.png'
import male3 from './avatar/male3.png'
import male4 from './avatar/male4.png'
import male5 from './avatar/male5.png'
import male6 from './avatar/male6.png'
import orion from './logo/orion.svg'
import turing from './logo/turing.svg'
import dataocean from './logo/dataocean.svg'
import convert from './logo/convert.svg'
import baldur from './logo/baldur.svg'
import indicator from './logo/indicator.svg'
import dispatch from './logo/dispatch.svg'
import feature from './logo/model.svg'
import model from './logo/model.svg'
import storage from './logo/storage.svg'
import bi from './logo/bi.svg'
import logo from './logo/default.svg'

export default {
  // theme
  themeSymbol1,
  themeSymbol2,

  // Avatar
  empty,
  female1,
  female2,
  female3,
  female4,
  female5,
  female6,
  male1,
  male2,
  male3,
  male4,
  male5,
  male6,
}

export const defaultLogo = logo

export const logoImgMap = {
  default: logo,
  bridge:
    'data:image/svg+xml;base64,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',
  orion,
  turing,
  dataocean,
  convert,
  baldur,
  indicator,
  dispatch,
  feature,
  model,
  storage,
  bi,
}
